<template>
  <div>
    <div class="table-list mt20">
      <div class="spec-head">
        <div class="sp-col">商品</div>
        <div class="sp-col">规格</div>
        <!-- <div class="sp-col">聚水潭编码</div> -->
        <template v-if="type != 2">
          <div class="sp-col">数量</div>
          <!-- <div class="sp-col" v-if="isGoods">单价</div> -->
          <div class="sp-col" v-if="type === 1">单价</div>
        </template>
        <div class="sp-col">操作</div>
      </div>
      <template v-if="(type ? form.giftData : form.giftData1).length === 0">
        <div class="spec-item">
          <div class="sp-col" style="flex: 1; text-align: center; color: #999;">暂无赠品，点击右侧添加</div>
          <div class="sp-col oper-icon">
            <i class="el-icon-plus" @click="handleAddItem"></i>
          </div>
        </div>
      </template>
      <div class="spec-item" v-for="(item, idx) in type?form.giftData:form.giftData1" :key="idx">
        <el-form-item class="sp-col" :prop="`${type ? 'giftData' : 'giftData1'}[${idx}].goodsId`" label-width="0" :rules="{required: type === 1,message: '请选择商品',trigger: 'change'}">
          <el-select v-model="item.goodsId" placeholder="请选择" filterable @change="(val) => handleChange(item, idx)">
            <el-option v-for="it in sysGoods" :key="it.id" :label="it.name" :value="it.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="sp-col" :prop="`${type ? 'giftData' : 'giftData1'}[${idx}].specValuecombineId`" label-width="0" :rules="{required: item.goodsId,message: '请选择规格',trigger: 'change',}">
          <span v-if="item.specArr && item.specArr.length === 1" class="spec-text">{{ item.productSpec || '无规格值' }}</span>
          <el-select v-else v-model="item.specValuecombineId" placeholder="请选择规格" @change="handleChangeSpec(item)">
            <el-option v-for="it in item.specArr" :key="it.id" :label="`${it.spec || '无规格值'}(${it.jushuitanCode})`" :value="it.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item class="sp-col" :prop="`${type ? 'giftData' : 'giftData1'}[${idx}].jushuitanCode`" label-width="0" >
          <el-input v-model="item.jushuitanCode" readonly />
        </el-form-item> -->
        <template v-if="type != 2">
          <el-form-item class="sp-col" :prop="`${type ? 'giftData' : 'giftData1'}[${idx}].num`" label-width="0" :rules="{required: item.goodsId,message: '请填写数量',trigger: 'change',}">
            <el-input v-model="item.num" placeholder="请输入数量" @input="handleChangePrice(item)" />
          </el-form-item>
          <!-- <el-form-item v-if="isGoods" class="sp-col" :prop="`${type ? 'giftData' : 'giftData1'}[${idx}].price`" label-width="0" :rules="{required: isGoods?false:true,message: '请填写',trigger: 'change',}">
            <el-input v-model="item.retailPrice" :disabled="isGoods" @change="handleChangePrice(item)" />
          </el-form-item> -->
          <el-form-item v-if="type === 1" class="sp-col" :prop="`${type ? 'giftData' : 'giftData1'}[${idx}].price`"
                        label-width="0"
                        :rules="{required: true,message: '请填写',trigger: 'change',}">
            <el-input v-model="item.price" placeholder="请输入商品单价" :disabled="isGoods" @input="handleChangePrice(item)" />
          </el-form-item>
        </template>
        <div class="sp-col oper-icon">
          <i class="el-icon-minus" @click="handleDeleteItem(idx)" v-if="(type && form.giftData.length > 1) || (!type && form.giftData1.length > 0)"></i>
          <i class="el-icon-plus" @click="handleAddItem"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageUpload from "@/components/ImageUpload";
import sysGoodsApi from '@/api/sys/sysGoods'
import { filterEmpty } from '@/utils/index'
export default {
  components: { ImageUpload },
  props: ['form', 'type', 'isPackage', 'isGoods', 'goodType'],
  data() {
    return {
      sysGoods: []
    }
  },
  created() {
    this.getGoods()
  },
  methods: {
    getGoods() {
      const params = {
        isPackage: this.isPackage,
        areaType: this.goodType
      }
      sysGoodsApi.getGoodRecomList({ ...filterEmpty(params) }).then(({ data }) => {
        this.sysGoods = data
        this.calcEdit()
      })
    },
    calcEdit() {
      const { id, giftData, giftData1 } = this.form;
      if (!id) return
      giftData && giftData.forEach(item => {
        const find = this.sysGoods.find(it => it.id === item.goodsId)
        // REQ-2026-234328：这里显示的是**产品规格**（sys_goods.product_spec）。
        // 老值 find.spec 是正在退役的自由文本「商品规格」，作为回退保留 ——
        // product_spec 是本期新加的列且没有存量回填，只写 product_spec 的话
        // 发版当天所有历史商品这一栏会集体空白。等存量迁移做完再把回退去掉。
        item.specArr = find ? find.specValueList : [];
        item.productSpec = find ? (find.productSpec || find.spec) : '';
      })
      giftData1 && giftData1.forEach(item => {
        const find = this.sysGoods.find(it => it.id === item.goodsId)
        item.specArr = find ? find.specValueList : [];
        item.productSpec = find ? (find.productSpec || find.spec) : '';
      })
    },
    handleDeleteItem(index) {
      if (this.type) {
        this.form.giftData.splice(index, 1)
      } else {
        this.form.giftData1.splice(index, 1)
      }
      this.$emit('update-retail-price')
    },
    handleChangeSpec(item) {
      const find = item.specArr.find(it => it.id === item.specValuecombineId)
      item.price = this.type === 1 ? find.retailPrice : 0;
      // item.jushuitanCode = find.jushuitanCode;
      this.$emit('update-retail-price')
    },

    handleChangePrice(item) {
      // 当价格改变时，触发父组件更新零售价
      this.$emit('update-retail-price')
    },
    handleAddItem() {
      if (this.type) {
        this.form.giftData.push({ goodsId: '', specValuecombineId: '', num: '', price: '' })
      } else {
        this.form.giftData1.push({ goodsId: '', specValuecombineId: '', num: '', price: '' })
      }
    },
    handleChange(item, idx) {
      const find = this.sysGoods.find(it => it.id === item.goodsId)
      item.specArr = find.specValueList;
      // REQ-2026-234328 产品规格优先，回退老的自由文本规格（见 calcEdit 里的说明）
      item.productSpec = find ? (find.productSpec || find.spec) : '';
      if (item.specArr && item.specArr.length === 1) {
        this.$set(item, 'specValuecombineId', item.specArr[0].id)
        this.handleChangeSpec(item)
      } else {
        this.$set(item, 'specValuecombineId', null)
        const dataForm = this.$parent.$refs.dataForm
        if (dataForm) {
          dataForm.validateField(`${this.type ? 'giftData' : 'giftData1'}[${idx}].specValuecombineId`)
        }
      }
      this.$emit('update-retail-price')
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item--small.el-form-item.w60 {
  width: 70%;
  display: inline-block;
  vertical-align: top;
  input {
    width: 40%;
  }
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
.flexs {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .oper {
    width: 300px;
    display: inline-block;
    font-size: 16px;
    span {
      padding-left: 20px;
      cursor: pointer;
    }
    .del {
      color: #e73f3f;
      padding-left: 20px;
    }
    .add {
      color: #5dbde7;
    }
  }
}
.table-list {
  border: 1px solid #e4e4e4;
  // margin: 0 35px 20px 50px;
  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      // flex-grow: 3;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.oper-icon {
  i {
    cursor: pointer;
    font-size: 22px;
    color: #465c99;
    &:nth-child(1) {
      padding-right: 5px;
    }
  }
}
</style>
